// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getFirestore, connectFirestoreEmulator } from "firebase/firestore";
import { getAuth, connectAuthEmulator } from "firebase/auth";
import { getStorage, connectStorageEmulator } from "firebase/storage";
import { getFunctions, connectFunctionsEmulator } from "firebase/functions";
import { getAnalytics } from "firebase/analytics";

// Firebase configuration
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

// Initialize Firebase services
export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);
export const functions = getFunctions(app);

// Initialize Analytics only in production
export const analytics = process.env.NODE_ENV === 'production' ? getAnalytics(app) : null;

// Connect to emulators in development
// Solo descomentar cuando estés ejecutando emuladores locales
// Para usar: firebase emulators:start
if (process.env.REACT_APP_USE_EMULATORS === 'true' && process.env.NODE_ENV === 'development') {
  console.log('🔧 Conectando a emuladores locales de Firebase...');
  // Descomenta estas líneas cuando quieras usar emuladores:
  // connectFirestoreEmulator(db, 'localhost', 8080);
  // connectAuthEmulator(auth, 'http://localhost:9099');
  // connectStorageEmulator(storage, 'localhost', 9199);
  // connectFunctionsEmulator(functions, 'localhost', 5001);
  console.log('✓ Emuladores configurados');
} else {
  // Producción: conectar a Firebase real
  console.log('🔥 Conectando a Firebase en producción (Project ID:', firebaseConfig.projectId, ')');
}

export default app;


